import React from 'react';
import withStyles from '@mui/styles/withStyles';
import Button from 'ui-components/button';

const styles = theme => ({
  root: {
    height: 100,
  },

});

const RegistrationCodeBox = ({
  classes,
  handleRegistrationCodeChange,
  handleRegistrationCodeSubmit,
}) => {
  return (
    <div className="login-registration">
      <div className="login-registration-title">Dein persönlicher Code</div>
      <input
        name="registration_code"
        className="login-box-input"
        placeholder="Ihr Code"
        onChange={handleRegistrationCodeChange}>
      </input>
      <div className="login-registration-button">
        <Button
          onClick={handleRegistrationCodeSubmit}
        >
          REGISTRIEREN
        </Button>
      </div>
    </div>
  );
};

export default withStyles(styles)(RegistrationCodeBox);
